$(window).scroll(function(){
  var scroll = $(window).scrollTop();
  if (scroll >= 2000) {
    $(".pdp-menu-top").css("display", "flex");
    $(".pdp-menu.flex").css("display", "flex");
  } else {
    $(".pdp-menu-top").css("display", "none");
    $(".pdp-menu.flex").css("display", "none");
  }

  const $stickyBar = $('section.pdp-menu.flex.wf-section.product_menu_section');
  const $mainAtc = $('.add-to-cart-holder .atcButtonWrap');

  function toggleStickyATC() {
    if($mainAtc){
      // desktop → always hide
      if ($(window).width() > 767) {
        $stickyBar.removeClass('visible');
        return;
      }

      // mobile logic
      const rect = $mainAtc[0].getBoundingClientRect();

      const isVisible =
        rect.top < window.innerHeight &&
        rect.bottom > 0;

      if (isVisible) {
        $stickyBar.removeClass('visible');
      } else {
        $stickyBar.addClass('visible');
      }
    }
  }

  // run on scroll + load + resize
  $(window).on('scroll load resize', function () {
    toggleStickyATC();
  });
  
})


$(document).ready(function() {

  $('.accordion_heading').on('click', function () {
    const $block = $(this).closest('.product_accordion_block');
    const $content = $block.find('.product_accordion_content');
  
    // Toggle both active and active_accordion classes
    $block.toggleClass('active_accordion');
  
    // Animate open/close
    $content.stop(true, true).slideToggle(300);
  });


  // =================================================================
      

    $('.product_size_tabs label').click(function(){

      $('.product_size_tabs label').removeClass('active_size_label');
        $(this).addClass('active_size_label');
        $('.product_size_block_row').removeClass('active_size_table');
      
        var size_label = $(this).attr('data-tab');
        $('.product_size_block_row[data-content="'+size_label+'"]').addClass('active_size_table');
      
    })
  
    $('.expert_product_lable').click(function() {
        $('.expert_form_container').addClass('active_form')
    })
    $('.close_btn').click(function() {
        $('.expert_form_container').removeClass('active_form')
    })



    
    function caesarCushieHomepageVariantProps() {
      var raw = null, parsed = null, cookieVariant = null;
      try { raw = localStorage.getItem('caesar_cushie_homepage_variant') || sessionStorage.getItem('caesar_cushie_homepage_variant'); } catch (e) {}
      if (raw) { try { parsed = JSON.parse(raw); } catch(e) {} }
      try { var m = document.cookie.match(/(?:^|; )caesar_cushie_homepage_variant=([^;]+)/); if (m) cookieVariant = decodeURIComponent(m[1]); } catch(e) {}
      var variant = (parsed && parsed.variant) || cookieVariant || null;
      if (variant !== 'control' && variant !== 'sleeper_sofa') variant = null;
      return {
        homepage_banner_flag_key: 'cushie-homepage-banner-routing-v1',
        homepage_banner_variant: variant,
        homepage_banner_source: (parsed && parsed.source) || null,
        homepage_banner_assigned_at: (parsed && parsed.assigned_at) || null,
        homepage_banner_smoke_test: !!(parsed && parsed.caesar_smoke_test),
        '$feature/cushie-homepage-banner-routing-v1': variant
      };
    }

    async function caesarCushiePersistHomepageVariantCartAttributes() {
      var props = caesarCushieHomepageVariantProps ? caesarCushieHomepageVariantProps() : {};
      if (!props.homepage_banner_variant) return props;
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {
            caesar_homepage_banner_flag_key: props.homepage_banner_flag_key,
            caesar_homepage_banner_variant: props.homepage_banner_variant,
            caesar_homepage_banner_source: props.homepage_banner_source || '',
            caesar_homepage_banner_assigned_at: props.homepage_banner_assigned_at || '',
            caesar_homepage_banner_smoke_test: props.homepage_banner_smoke_test ? 'true' : 'false'
          }})
        });
      } catch(e) {}
      return props;
    }
function sendPostHogAddToCartSuccess(payload) {
      fetch('https://us.i.posthog.com/capture/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          api_key: 'phc_qJ5kpUyq4sdJxMud3o9P3t6MYE6ibuBAcJJCmxGAks4f',
          event: 'product added to cart',
          distinct_id: window.ShopifyAnalytics && ShopifyAnalytics.lib
            ? ShopifyAnalytics.lib.user && ShopifyAnalytics.lib.user().traits().uniqToken
            : 'cushie-anonymous',
          properties: Object.assign({
            source: 'shopify_theme_atc_success',
            caesar_tracking_version: 'cushie-theme-atc-success-2026-05-28-homepage-variant',
            trigger: 'cart_add_success',
            product_id: payload.product_id || null,
            variant_id: payload.variant_id || null,
            sku: payload.sku || null,
            quantity: payload.quantity || 1,
            url: window.location.href,
            page_path: window.location.pathname
          }, caesarCushieHomepageVariantProps())
        })
      }).catch(function() {});
    }

    function initialize_slider() {
        const all_review_data = new Swiper('.cart_review_slider', {
            slidesPerView: 1,
            spaceBetween: 40,
            grabCursor: !0,
            navigation: {
                nextEl: '.cart-review-btn-next',
                prevEl: '.cart-review-btn-prev'
            }
        })
    }
    initialize_slider();

    function initialize_prd_reviews(){
         const review_cart_box = new Swiper('.block_reviews',{
          slidesPerView: 1,
          spaceBetween: 10, 
          navigation: {
            nextEl: '.review-cart-prd-next',
            prevEl: '.review-cart-prd-prev'
          }
        });
      
    }
    initialize_prd_reviews();
  
    async function cart_update() {
      const res = await fetch("/?section_id=cart-drawer-pdp");
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const newBox = html.querySelector(".cart-wrapper").innerHTML;
      document.querySelector(".cart-wrapper").innerHTML = newBox;
      const cart_inf = await fetch("/cart.js");
      const cart = await cart_inf.json();
      await updateCounter(cart.item_count);
    }

    $(document).on('click', '.you_may_prd_btn', async function(e) {
        e.preventDefault();
      console.log('adddd');
        var variant_id = $(this).attr('prd-variant-id');
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: [{
                    id: variant_id,
                    quantity: 1
                }, ]
            },
            dataType: 'json',
            success: async function(data) {
                await cart_update();
                initialize_prd_reviews();
            }
        })
    })

    $(document).on('click', '.remove-button-2', async function () {
      var selected_variant_id = $(this).parents('.cart_qty_remove_btn').find('.cart_quantity .quantity').attr('name');
      var free_shipping_bar = $('.cart_drawer_free_shipping_bar');
    
      const cart_inf = await fetch("/cart.js");
      const cart = await cart_inf.json();
    
      var updates_id = {
        updates: {
          [selected_variant_id]: 0
        }
      };
    
      $.ajax({
        url: "/cart/update.js",
        data: updates_id,
        dataType: 'json',
        type: "POST",
        success: async function (data) {
          console.log("data", data);
          if (data.items.length == 0) {
            console.log("cursor in!");
            free_shipping_bar.attr('cart-items', 0);
            try {
              let removeDiscountResponse = await fetch("/discount/CLEAR", {
                method: "GET",
                headers: { "Content-Type": "application/json" },
              });
    
              if (!removeDiscountResponse.ok) {
                throw new Error("Failed to remove discount");
              }
    
            } catch (error) {
              console.error("Error removing discount:", error);
            }
          }
    
          await updateCart();
          initialize_slider();
        }
      });
    });



    function setUpButtons() {
      const cartOpenLink = document.querySelector(".w-commerce-commercecartopenlink");
      const closeButton = document.querySelector(".close-button");
      const cartOverlay = document.querySelector(".left_cart_drawer_side");

      if (cartOpenLink) {
        cartOpenLink.addEventListener("click", (e) => {
          e.preventDefault();
          openCart();
        });
      }

      if (closeButton) {
        closeButton.addEventListener("click", (e) => {
          e.preventDefault();
          closeCart();
        });
      }

      if (cartOverlay) {
        cartOverlay.addEventListener("click", (e) => {
          e.preventDefault();
          closeCart();
        });
      }
    }

    function closeCart() {
        const cartDrawer = document.querySelector('.cart-wrapper');
        if (cartDrawer) {
            cartDrawer.classList.remove("active_cart_drawer");
            cartDrawer.removeAttribute('data-cart-open')
        }
    };
    $('.left_cart_drawer_side').click(function() {
        closeCart()
    });

    function openCart() {
        const cartDrawer = document.querySelector('.cart-wrapper');
        if (cartDrawer) {
            cartDrawer.classList.add("active_cart_drawer")
        }
    };
    async function setUpDelete() {
        document.querySelectorAll(".remove-button-2").forEach((button) => {
            button.addEventListener("click", async (e) => {
                if (e.target.classList.contains('remove-button-2')) {
                    e.preventDefault();
                    let quant = button.parentElement.parentElement.querySelector('.quantity');
                    let key = quant.getAttribute("name");
                    let newQuantity = quant.value;
                    await fetch("/cart/update.js", {
                        method: "post",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            updates: {
                                [key]: 0
                            }
                        }),
                    }).then(response => {
                        if (response.ok) {} else {}
                    });
                    await updateCart();
                    initialize_slider();
                    openCart()
                }
            })
        })
    }
  
    async function updateCart() {
      const wrapper = $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper');
      const loader = wrapper.find('.cart-total-loader');
      const cartWrapper = document.querySelector(".cart_drawer");
      const cartHeader = document.q

      wrapper.addClass('show-loader');
      loader.removeClass('hide');

      try {
        const [sectionRes, cartRes] = await Promise.all([
          fetch("/?section_id=cart-drawer-pdp"),
          fetch("/cart.js")
        ]);

        const [text, cart] = await Promise.all([
          sectionRes.text(),
          cartRes.json()
        ]);

        // Parse HTML once
        const html = document.createElement("div");
        html.innerHTML = text;

        const newContent = html.querySelector(".cart_drawer");
        if (newContent && cartWrapper) {
          cartWrapper.innerHTML = newContent.innerHTML;
        }
        
        // Rebind events
        setUpButtons();
        setUpDelete();

        // Update counter
        updateCounter(cart.item_count);

      } catch (error) {
        console.error("Cart update failed:", error);
      } finally {
        wrapper.removeClass('show-loader');
        loader.addClass('hide');
        $('.cart_quantity').removeClass('load_cart');
        $('#cart-checkout-button').removeClass('disabled-checkout');
      }
    }
      
    setUpDelete();

    function updateCounter(item_count) {
        const tmp = document.querySelector(".cart-quantity");
        tmp.textContent = item_count
    };
    setUpButtons();

  
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

    if (addToCartForms.length > 0) {
      addToCartForms.forEach((form) => {
        let isRunning = false;
        const submitButton = form.querySelector('input[type="submit"]');
    
        if (!submitButton) return;
    
        submitButton.addEventListener("click", async (e) => {
          e.preventDefault();
    
          let but2 = document.getElementById('primar-button');
          let old_text2 = but2?.value || "Adding ...";
          if (but2) but2.value = "Adding ...";
    
          if (isRunning) return;
          isRunning = true;
    
          try {
            const formData = new FormData(form);
    
            /* await fetch("/cart/add", {
              method: "POST",
              body: formData,
            }); */

            const response = await fetch("/cart/add.js", {
              method: "POST",
              body: formData,
            });

            const data = await response.json();
            if (response.ok) {
              await caesarCushiePersistHomepageVariantCartAttributes();
              await caesarCushiePersistHomepageVariantCartAttributes();
            sendPostHogAddToCartSuccess({
                variant_id: data.variant_id || data.id,
                product_id: data.product_id,
                sku: data.sku,
                quantity: data.quantity
              });
            }
            openCart();
            await updateCart();
            
          } catch (error) {
            console.error("Add to cart error:", error);
          } finally {
            if (but2) but2.value = old_text2;
            isRunning = false;
          }
        });
      });
    }


    const stickyAtcButton = document.querySelector('.sticky-atc-wrapper .sticky-atc-container .atcBtn button#sticky-atc-btn');

    if (stickyAtcButton) {
      let isRunning = false;

      stickyAtcButton.addEventListener('click', async function (e) {
        e.preventDefault();

        if (isRunning) return;
        isRunning = true;

        const variantIdInput = document.querySelector('.speical-holder .add-to-cart-container .w-commerce-commerceaddtocartform input[name="id"]');
        const variantId = variantIdInput?.value;

        const buttonEl = this; // ✅ now this correctly refers to the clicked button
        const loadingText = buttonEl.getAttribute('data-loading-text') || 'Adding...';
        const originalText = buttonEl.innerHTML;

        if (!variantId || variantId === 'undefined') {
          console.log('Please select a valid variant before adding to cart.');
          isRunning = false;
          return;
        }

        // Show loading text with icon
        buttonEl.innerHTML = `${loadingText} <span class="sticky-atc-icon"><img src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418" alt="icon"></span>`;

        try {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', 1);

          /* await fetch('/cart/add', {
            method: 'POST',
            body: formData
          }); */

          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });

          const data = await response.json();
          if (response.ok) {
            sendPostHogAddToCartSuccess({
              variant_id: data.variant_id || data.id,
              product_id: data.product_id,
              sku: data.sku,
              quantity: data.quantity
            });
          }

          openCart();       // Call your cart drawer function
          await updateCart(); // Call your cart UI updater if needed

        } catch (error) {
          console.error('Add to cart error:', error);
        } finally {
          buttonEl.innerHTML = originalText;
          isRunning = false;
        }
      });
    }

  
    $(document).ready(function() {
        var $button = document.getElementById('updateButton');
        $(document).on('click', '.old-plus', function() {
            var $input = $(this).closest('.quantity-block').find('.quantity');
            var val = parseInt($input.val(), 10);
            $input.val(val + 1);
            $input[0].dispatchEvent(new Event('change'));
            $button.click()
        });
        $(document).on('click', '.old-minus', function() {
            var $input = $(this).closest('.quantity-block').find('.quantity');
            var val = parseInt($input.val(), 10);
            $input.val(Math.max(val - 1, 1));
            $input[0].dispatchEvent(new Event('change'));
            $button.click()
        });
        $('select[data-node-type="add-to-cart-option-select"]').change(function() {
            setTimeout(function() {
                location.reload()
            }, 1000)
        });

      
        /* $(document).on('click', '.plus', async function() {
            if(!$(this).hasClass('cart-qty-btn')){
              var $input = $(this).closest('.quantity-block').find('.quantity');
              $(this).parents('.cart_quantity').addClass('load_cart');
              $input[0].stepUp();
              $input.trigger('input');
              var $name = $input.attr("name");
              var updates = {};
              updates[$name] = $input.val();
              let key = $name;
              let quant = $input.val();
              await fetch("/cart/update.js", {
                  method: "post",
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                      updates: {
                          [key]: quant
                      }
                  }),
              });
              await updateCart()
            }
        }); 
        

        $(document).on('click', '.minus', async function() {
          if(!$(this).hasClass('cart-qty-btn')){
            var $input = $(this).closest('.quantity-block').find('.quantity');
            $(this).parents('.cart_quantity').addClass('load_cart');
            $input[0].stepDown();
            $input.trigger('input');
            var $name = $input.attr("name");
            var updates = {};
            let key = $name;
            let quant = $input.val();
            await fetch("/cart/update.js", {
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    updates: {
                        [key]: quant
                    }
                }),
            });
            await updateCart()
          }
        }) */


        let cartUpdateTimerPlus;
        let plusInitialQty = 0;
        
        $(document).on('pointerdown', '.plus', function () {
          if (!$(this).hasClass('cart-qty-btn')) {
            const $input = $(this).closest('.quantity-block').find('.quantity');
            const currentQty = parseInt($input.val());
        
            // If this is the first interaction in a burst, store the initial quantity
            if (plusInitialQty === 0) {
              plusInitialQty = currentQty;
            }
        
            const maxQty = plusInitialQty + 15; // Changed to 15
        
            // Only allow increasing up to 15 units more than initial
            if (currentQty < maxQty) {
              $input[0].stepUp();
              $input.trigger('input');
        
              clearTimeout(cartUpdateTimerPlus);
        
              cartUpdateTimerPlus = setTimeout(async function () {
                const key = $input.attr("name");
                const qty = $input.val();
        
                const updates = { [key]: qty };
        
                try {
                  await fetch("/cart/update.js", {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ updates })
                  });
        
                  await updateCart();
                } catch (error) {
                  console.error('Error updating cart:', error);
                }
        
                plusInitialQty = 0;
              }, 500);
            }
          }
        });


        let cartUpdateTimerMinus;
        let initialQtyMapMinus = new Map();
        
        $(document).on('pointerdown', '.minus', function () {
          if (!$(this).hasClass('cart-qty-btn')) {
            const $input = $(this).closest('.quantity-block').find('.quantity');
            const key = $input.attr("name");
            const currentQty = parseInt($input.val(), 10);
        
            // Store initial qty only once
            if (!initialQtyMapMinus.has($input[0])) {
              initialQtyMapMinus.set($input[0], currentQty);
            }
        
            const initialQty = initialQtyMapMinus.get($input[0]);
            const newQty = currentQty - 1;
        
            // Prevent going below 1
            if (newQty < 1) return;
        
            // Allow up to 15 units decrement
            if ((initialQty - newQty) > 15) return;
        
            $input[0].stepDown();
            $input.trigger('input');
        
            clearTimeout(cartUpdateTimerMinus);
        
            cartUpdateTimerMinus = setTimeout(async function () {
              const finalQty = parseInt($input.val(), 10);
              const updates = { [key]: finalQty };
        
              try {
                await fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ updates })
                });
        
                await updateCart();
        
                initialQtyMapMinus.delete($input[0]);
        
              } catch (error) {
                console.error('Error updating cart:', error);
              }
            }, 500);
          }
        });



    })

  
    $('.size_guide').click(function() {
        $('.product_size_guide_container').addClass('active_size')
    });
    $('.close_size').click(function() {
        $('.product_size_guide_container').removeClass('active_size')
    })
    $('.dimensions_image_thumb img').click(function() {
        $('.dimensions_thumb_imgs').removeClass('active_thumb');
        var select_mode = $(this).attr('image-name');
        $(this).parents('.dimensions_thumb_imgs').addClass('active_thumb');
        $(this).parents('.dimensions_grid').find('.dimensions_images img').removeClass('active');
        $(this).parents('.dimensions_grid').find('.dimensions_images img[name=' + select_mode + ']').addClass('active')
    });
     $('.see_all_reviews').click(function() {
        const primarySection = $('#shopify-section-template--24566500294947__1746683689f837f62c');
        const fallbackSection = $('#shopify-section-template--24533156954403__174486990997d282ff');
        
        // Choose the section that exists
        const targetSection = primarySection.length ? primarySection : fallbackSection;
        
        // Scroll to the target section if it exists
        if (targetSection.length) {
          $("body, html").animate({
            scrollTop: targetSection.offset().top - 20
          }, 1000);
        }
      });
    if (window.innerWidth < 767) {
        var review_html = $('.review_layout_1').html();
        $('.mobile_review_layout_1').append(review_html)
    } else if (window.innerWidth >= 768 || window.innerWidth <= 1024) {
        var review_html = $('.review_layout_1').html();
        $('.mobile_review_layout_1').append(review_html)
    }
    $(document).on('click', '.mobile_review_layout_1 .review_all_btn', function() {
        /* console.log('click all');
        $("body, html").animate({
            scrollTop: $($('#reviews')).offset().top - 20
        }, 1000) */

        $(this).closest('.swiper-slide').find('.review_content p').css('-webkit-line-clamp','inherit');
        $(this).hide();

    })


    $('.product_accordion_container .reviews_acordion_content .see_all_reviews').on('click', function(e){
      e.preventDefault();
      if($('.junip-product-review-rendered').length > 0){
        $('html, body').animate({
          scrollTop: $('.junip-product-review-rendered').offset().top
        }, 800);
      }
    })
  
})


$(document).ready(function () {
    // Divide value (static ya dynamically assign kar sakte ho)
    var divideValue = 12;

    setTimeout(function() {
      var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
      // $('#properties').val(variation_date);
    }, 500);

    $('.variation-swatch').on('click', function () {
      var price = $(this).attr('data-variant-price');

      if (price) {
        // Clean price (remove $ or commas)
        var cleanPrice = parseFloat(price.replace(/[^0-9.]/g, ''));

        // Monthly installment calculation
        var monthly = (cleanPrice / divideValue).toFixed(2);
        var installmentText = `$${monthly}/Month`;

        // 1. Append to .metafield-string
        $('.metafield-string').html(installmentText);

        // 2. Prepend the actual price to .sale_cust_price_2
        $('.sale_cust_price_2 .original-price s').html(`$${price}`);
      }

      var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
      // $('#properties').val(variation_date);
      
    });
  
  });


  function handleCheckoutClick(e) {
    const $btn = $(this);
    const $loadingText = $btn.attr('data-loading-text');
  
    if ($btn.hasClass('disabled-checkout')) return;
  
    e.preventDefault();
  
    if ($loadingText) {
      $btn.find('.checkBtnText').text($loadingText);
    }
  
    setTimeout(() => {
      $btn.find('.checkBtnText').text('Checkout');
    }, 1000);
  
    const url = $btn.attr('href');
    if (url) {
      window.location.href = url;
    }
  }
  
  // Use event delegation on a stable parent like body or cart drawer
  $(document).on('click', '#cart-checkout-button', handleCheckoutClick);
  
  // Rebind only needed if using direct binding, but we're now using delegation
  window.addEventListener('pageshow', function (event) {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
      console.log('Restored from bfcache – no need to rebind due to delegation');
    }
  }); 
